module.exports = __webpack_public_path__ + "img/middle-border.6b596e86.png";